module.exports = __webpack_public_path__ + "prod/1.42.2/img/icon-attention.2e2c0efd.svg";